import { FC, ChangeEvent } from "react"
import styled from "styled-components"

interface Props {
  name: string
  title: string
  filters: string[]
  state: any
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
}

export const ButtonFilter: FC<Props> = ({
  name,
  title,
  filters,
  state,
  onChange,
}) => {
  const filterState = state[name]

  return (
    <StyledButtonFilter>
      <Title>{title}</Title>
      <CheckboxContainer>
        {filters.map(filter => {
          return (
            <CheckboxButton
              key={filter}
              $isActive={filterState?.includes(filter)}
            >
              {filter}
              <Input
                type="checkbox"
                name={name}
                id={filter}
                value={filter}
                onChange={e => onChange(e)}
              />
            </CheckboxButton>
          )
        })}
      </CheckboxContainer>
    </StyledButtonFilter>
  )
}

interface CheckboxProps {
  $isActive: boolean
}

const StyledButtonFilter = styled.div``

const Title = styled.div`
  margin: 0 0 1.4rem;
  text-transform: uppercase;
  font-size: 1rem;
  line-height: 2.4rem;
  letter-spacing: 1.67px;
`

const CheckboxContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, calc((100% / 3) - (2.4rem / 3)));
  grid-auto-flow: row;
  grid-gap: 1.2rem;

  @media (min-width: ${({ theme }) => theme.breakpoint.md}px) {
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 1.84rem;
  }
`

const CheckboxButton = styled.label<CheckboxProps>`
  position: relative;
  display: grid;
  place-items: center;
  text-transform: uppercase;
  font-size: 1.2rem;
  line-height: 1.4rem;
  letter-spacing: 2px;
  width: 100%;
  height: 4rem;
  border-radius: 3px;
  border: 1px solid ${({ theme }) => theme.color.black};
  background: ${({ $isActive, theme }) =>
    $isActive ? theme.color.black : "transparent"};
  color: ${({ $isActive, theme }) =>
    $isActive ? theme.color.white : theme.color.black};

  transition: ease-out 0.25s;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.color.black};
    color: ${({ theme }) => theme.color.white};
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.md}px) {
  }
`

const Input = styled.input`
  position: absolute;
  top: 0;
  left: 0;
  margin: 0;
  opacity: 0;
  cursor: pointer;
  height: 100%;
  width: 100%;
`
